
import styled from 'styled-components'
// We use Prism because is the only one that supports jsx
import { PrismAsyncLight as SyntaxHighlighter } from 'react-syntax-highlighter'
import {
  P, H2, H3, H4,
} from 'common/typography'
import BigImage from 'post/big-image'
import Picture from 'post/picture'
import { IoIosLink } from 'react-icons/io'
import { TransparentButton } from 'components/common/button'
import monaki from './code-styles'

const IframeStyled = styled.iframe`
  max-inline-size: 100%;
  height: auto;
  aspect-ratio: 16/9;
`

export const renderers = {
  paragraph: (props) => <P {...props} overflow="unset" className="blog-content" />,
  heading: (props) => {
    if (props.level === 1) return null
    if (props.level === 2) return <H2 {...props} />
    if (props.level === 3) return <H3 {...props} />
    if (props.level === 4) return <H4 {...props} />
  },
  image: (props) => (
    <BigImage {...props} />
  ),
  // thematicBreak: () => (
  //   <Divider
  //     stroke={1}
  //     color="#AEB7C1"
  //     opacity="0.3"
  //     marginVertical={20}
  //   />
  // ),
  code: (props) => {
    const { value, language } = props
    const languageJS = (!language || language === 'js') && 'javascript'
    return (
      <SyntaxHighlighter language={languageJS || language} style={monaki}>
        {value}
      </SyntaxHighlighter>
    )
  },
  link: (props) => (props.href.includes('#') ? <a {...props} /> : <a target="_blank" rel="noopener noreferrer" {...props} />),
}

const CodeStyled = styled.code`
  padding: 4px;
  color: var(--lightBlue);
  background: var(--neutral100);
`

export function Code({ children, inline }) {
  if (inline) {
    return (
      <CodeStyled>{children}</CodeStyled>
    )
  }
  return (
    <SyntaxHighlighter language="javascript" style={monaki}>
      {children}
    </SyntaxHighlighter>
  )
}

function Hello() {
  return (
    <p>Hello World</p>
  )
}

function PComponent({ children }) {
  if (typeof children === 'string') {
    return <p>{children}</p>
  }
  const hasImage = !!children?.find(
    (child) => typeof child === 'object' && child.key && !!child.key.match(/img/g),
  )
  if (typeof children[0] === 'string' && children[0].includes('[YouTube ')) {
    const youtubeId = children[0].slice(9, -1)
    return (
      <>
        {/* <Script src="https://www.youtube.com/iframe_api" /> */}
        <IframeStyled
          title={youtubeId}
          allowFullScreen="allowFullScreen"
          src={`https://www.youtube.com/embed/${youtubeId}?ecver=1&amp;iv_load_policy=3&amp;rel=0&amp;yt:stretch=16:9&amp;autohide=1&amp;color=red&amp;width=560&amp;width=680`}
          width="680"
          height="383"
          allowTransparency="true"
          frameBorder="0"
        />
      </>
    )
  }
  return hasImage ? children : <p>{children}</p>
}

function Iframe(props) {
  return (
    <iframe {...props} />
  )
}

function aComponent({ children, href }) {
  return (
    <a href={href} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  )
}

const SubtitleComponentStyled = styled.div`
  scroll-margin-top: var(--headerBlockSize);
  margin-block-start: 2rem;
  svg {
    visibility: hidden;
    margin-inline-start: .5rem;
  }
  &:hover {
    text-decoration: underline;
    svg {
      visibility: visible;
    }
  }
`

function subtitleComponent(props) {
  const { children, node: { tagName } } = props
  const [str] = children
  if (typeof str === 'string') {
    const id = str.toLowerCase().replaceAll(' ', '-')
    return (
      <SubtitleComponentStyled id={id} as={tagName}>
        <a href={`#${id}`} title={`Link a ${str}`}>
          {children}
        </a>
        <IoIosLink size={18} color="var(--turquoise)" />
      </SubtitleComponentStyled>
    )
  }
  return (
    <SubtitleComponentStyled as={tagName}>
      {children}
    </SubtitleComponentStyled>
  )
}

function Script({ children }) {
  return (
    <div>
      {children}
    </div>
  )
}

export const components = {
  code: Code,
  img: BigImage,
  p: PComponent,
  iframe: Iframe,
  a: aComponent,
  h2: subtitleComponent,
  h3: subtitleComponent,
  h4: subtitleComponent,
  h5: subtitleComponent,
  h6: subtitleComponent,
}

export const mdxComponents = {
  Script,
  Hello,
  BigImage,
  Picture,
  code: Code,
  img: BigImage,
  p: PComponent,
  iframe: Iframe,
}

export const commentComments = {
  code: Code,
  a: ({ href, children }) => (
    <a href={href} target="_blank" rel="noopener noreferrer">{children}</a>
  ),
  // code,
  // em,
  // li,
  // ol,
  // p,
  // ul,
  // pre,
  // strong,
  // blockquote,
  h1: 'p',
  h2: 'p',
  h3: 'p',
  h4: 'p',
  h5: 'p',
  h6: 'p',
  hr: 'p',
  img: ({ src, title }) => (
    <p>
      ![
      {src}
      ]
      {title}
    </p>
  ),
}
